import { Handle, Position } from '@xyflow/react';
import { CButton } from '@coreui/react';
import { X } from 'lucide-react'; // icona per la X di eliminazione card
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const CardTextNode = ({ id, data }) => {

  const navigate = useNavigate();

  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation(); 
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);


  return (
    <div style={{
      padding: '10px',
      border: '3px solid #FF8647',
      boxShadow: '0 0 30px #FF8647',
      borderRadius: '15px',
      backgroundColor: 'var(--background-card-color)',
      textAlign: 'center',
    }}>
      {/* pulsante X per eliminare */}
      <button
        onClick={handleDeleteClick}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          color: '#FF8647',
          cursor: 'pointer',
        }}
        title="Elimina nodo"
      >
        <X size={13} />
      </button>
      <p style={{color: 'white', fontWeight: '700', borderBottom: '1px solid #FF8467'}}>{data.node.title || t('title.card_text')}</p>

      <CButton
        style={{
          borderRadius: '15px',
          backgroundColor: '#FF8647'
        }}
        className='text-uppercase text-white'
        size="sm"
        onClick={() => navigate(data.node.id+'/edit-cardtext')}
      >
        {t('button.edit')}
      </CButton>
      
      {/* Handles per connettere i nodi */}
      <Handle type="target" position={Position.Left} />

    </div>
  );
};

export default CardTextNode;
